module.exports = __webpack_public_path__ + "img/waterfalls-pool-2.8e16546f.jpg";